<template>
<div id="pageDashboard">
    <v-container grid-list-xl fluid>
        <v-toolbar card color="white">
            <v-toolbar-title>
                <h3>Code Analytics</h3>
                 <p class="subtitle">Below is a list of all the current codes available.</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
       
        </v-toolbar>

        <v-layout wrap>
            <v-flex xs12>
                <template>
                    <v-card>
                        <v-card-text class="pa-0 mt-2">
                            <v-spacer></v-spacer>
                            <v-layout row wrap>
                               
                            </v-layout>
                            <v-spacer></v-spacer>
                            <v-data-table :disable-initial-sort="true" :headers="headers" :items="imrDetails" :rows-per-page-items="[10,25,50,{text:'All','value':-1}]" class="elevation-1">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.item.code_name}} </td>
                                    <td>{{ props.item.hit.reduce((a, b) => a + b, 0) }}</td>
                                    <td>{{ props.item.completed.reduce((a, b) => a + b, 0) }}</td>                                    
                                </template>
                            </v-data-table>

                            <v-divider></v-divider>
                        </v-card-text>
                    </v-card>
                </template>
            </v-flex>
        </v-layout>

        <v-toolbar id="CreateCode" card color="white">
            <v-toolbar-title>
                <h3>Invite Users</h3>
                <!--<p class="subtitle">Create your custom codes below.</p>-->
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-layout row wrap>
                <p></p>
            </v-layout>
        </v-toolbar>

        <v-layout wrap>
            <v-flex xs12>
                <template>
                    <v-card>
                        <v-card-text class="pa-0 mt-2">
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    
                                    <v-flex lg8 md8 xs12>
                                        <v-select class="custom_dropdown" v-validate="'required'" :items="imrsList" :error-messages="errors.collect('code')" data-vv-name="code" v-model="form.code" required data-vv-as="Code" item-text="name" item-value="code" label="Select Code to invite *">
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex lg4 md4 xs12>
                                        <v-text-field label="First and Last Name *" :maxlength="32" v-model="form.name" v-validate="{required: 'form.name', max: 32,'restrictedWord':[]}" data-vv-name="name" placeholder="" :error-messages="errors.collect('name')" required data-vv-as="Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg4 md4 xs12>
                                        <v-text-field label="Email Address *" :maxlength="32" v-model="form.email" v-validate="{'required': 'form.email', 'email':true,'restrictedWord':[]}" data-vv-name="email" placeholder="" :error-messages="errors.collect('email')" required data-vv-as="Email">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>                                
                                <div class="form-btn text-xs-right">
                                  <v-btn @click="resetForm" color="gray white--text"><v-icon color="white">fa-times-circle</v-icon>Cancel</v-btn>
                                  <v-btn @click="submit" color="orange white--text" slot="activator"> Share </v-btn>
                                </div>
                            </v-container>

                        </v-card-text>
                    </v-card>
                </template>
            </v-flex>
        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";
import config from "../../config";
import services from "../../services/HttpService";
import GoogleAds from "@/pages/widgets/GoogleAds";
import {Validator} from 'vee-validate';


export default {
    components: {
        GoogleAds,
    },
    created (){
        const self = this,
            wApp = window.getApp;
        wApp.$emit("showLoader", {
            show: true
        });
        axios.all([
                self.getImrsList()
                    .then(dataResults => {
                        return dataResults;
                })
                .catch(err => {
                    console.log(err)
                }),
                self.getImrsDetails()
                    .then(dataResults => {
                        return dataResults;
                })
                .catch(err => {
                    console.log(err)
                }),
            ])
            .then(axios.spread(function (imrs, resImrDetails) {
                wApp.$emit("showLoader", {
                    show: false
                });

                self.imrsList.push({
                    'name': 'Select Code to invite',
                    'code': ''
                });
                if (imrs.data.data.length > 0) {
                    imrs.data.data.map(function (data) {
                        let newArr = {};
                        newArr.name = data.code_name;
                        newArr.code = data.code;
                        self.imrsList.push(newArr);
                    })
                }

                if(resImrDetails.data.data.length > 0){
                    let imrDetails = {};
                    resImrDetails.data.data.map(function(val){
                        if(val.code != ''){
                            if(typeof imrDetails[val.code] == 'undefined'){
                                imrDetails[val.code] = {};
                                imrDetails[val.code]['code'] = val.code;
                                imrDetails[val.code]['code_name'] = val.code_name;
                                imrDetails[val.code]['hit'] = [];
                                imrDetails[val.code]['hit'].push(val.hit_count);
                                imrDetails[val.code]['completed'] = [];
                                imrDetails[val.code]['completed'].push(val.sign_up_count);
                            } else {
                                imrDetails[val.code]['hit'].push(val.hit_count);
                                imrDetails[val.code]['completed'].push(val.sign_up_count);
                            }
                        }
                    });
                    let newArr = [];
                    Object.keys(imrDetails).map(function(key) {
                        newArr.push(imrDetails[key]);
                    });
                    self.imrDetails = newArr;
                }
            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
            });
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },        
        getImrsList(){
            const self = this;
            return new Promise(function(resolve, reject) {
                services.get("imrs/list", {
                    Authorization: "Bearer " + self.$store.state.user.token
                })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                });                
            });
        },
        getImrsDetails(){
            const self = this;
            return new Promise(function(resolve, reject) {
                services.get("imr-details/list", {
                    Authorization: "Bearer " + self.$store.state.user.token
                })
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                });                
            });
        },
        submit() {
            const self = this,
                wApp = window.getApp;
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        const formData = Object.assign({}, self.form);
                        formData.url = config.imrReferralUrl+"utm_campaign=imr&utm_code="+self.form.code;
                        delete formData.code;
                        services.post('imrs/invite-user', formData, {
                                    Authorization: "Bearer " + this.$store.state.user.token
                                })
                            .then(res => {
                                if (res.status === 200) {
                                    self._showToast(res.data.message, 'green');
                                    self.resetForm()
                                } else {                                    
                                    self._showToast(res.data.message, 'red');
                                }
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, 'red');
                            });
                    }
                })
                .catch(err => {});
        },
        resetForm(){
            const self = this;
            self.$validator.reset();
            self.form = Object.assign({},self.defaultFormData);
        },
    },
    data() {
        return {
            imrDetails:[],
            imrsList: [],
            defaultFormData: {
                name: '',
                code: '',
                email: '',
            },
            form: {
                name: '',
                code: '',
                email: '',
            },
            headers: [{
                    text: 'Code Name',
                    align: 'left',
                    value: 'code_name'
                },
                {
                    text: 'Clicked?',
                    align: 'left',
                    value: 'hit',
                    sortable: false,
                },
                {
                    text: 'Completed?',
                    align: 'left',
                    value: 'completed',
                    sortable: false,
                },
            ],
        }
    },
};
</script>

<style lang="stylus">
.custom_table th,.custom_table td
  padding: 5px;
.v-input--selection-controls__ripple, .v-input--selection-controls__input
  height:auto;
  width:auto;
.v-input--selection-controls
  margin-top: 0px; 
.v-btn.remove-border
  border: none !important;
</style>



// WEBPACK FOOTER //
// src/pages/imr/invite.vue